/**
 * `<RecordAbsenceHost/>` — mounts *Record absence* once (#2029).
 *
 * The app shell renders it beside `<FixAndResolveHost/>`. It shows nothing
 * until the roster toolbar's **Record absence** arms
 * `useRecordAbsenceStore`; then the panel opens as a small 360 px non-modal
 * side panel (`CycleSurfaceModal` `md`, a bottom sheet on a phone): the
 * roster stays readable and clickable behind it, and the *off sick* tag and
 * the −N appear there as the write lands.
 */
import { useRecordAbsenceStore } from "../../store/recordAbsenceRequest";
import { CycleSurfaceModal } from "../cycle/CycleSurfaceModal";
import { RecordAbsencePanel } from "./RecordAbsencePanel";

export function RecordAbsenceHost() {
  const request = useRecordAbsenceStore((s) => s.request);
  const close = useRecordAbsenceStore((s) => s.closeRecordAbsence);
  return (
    <CycleSurfaceModal
      open={request !== null}
      onOpenChange={(next) => {
        if (!next) close();
      }}
      title="Record absence"
      description="Off sick or on leave, for anyone on the team"
      testid="record-absence-surface"
      panelWidth="md"
    >
      {request ? (
        <RecordAbsencePanel
          // A new open starts on a blank form.
          key={`${request.teamId}|${request.dates.from}|${request.dates.to}`}
          request={request}
          onClose={close}
        />
      ) : null}
    </CycleSurfaceModal>
  );
}

export default RecordAbsenceHost;
